import { render, staticRenderFns } from "./SurveyItem.vue?vue&type=template&id=0b573bf1&scoped=true&"
import script from "./SurveyItem.vue?vue&type=script&lang=ts&"
export * from "./SurveyItem.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyItem.vue?vue&type=style&index=0&id=0b573bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b573bf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b573bf1')) {
      api.createRecord('0b573bf1', component.options)
    } else {
      api.reload('0b573bf1', component.options)
    }
    module.hot.accept("./SurveyItem.vue?vue&type=template&id=0b573bf1&scoped=true&", function () {
      api.rerender('0b573bf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SurveyItem.vue"
export default component.exports